import {RouteRecordRaw} from 'vue-router'
import HomeProgetti from "@/views/HomeProgetti.vue";
import InserimentoTimesheet from "@/views/Timesheet/InserimentoTimesheet.vue";
import TimesheetMenu from "@/components/Timesheet/TimesheetMenu.vue";
import ControlloTimesheet from "@/views/Timesheet/ControlloTimesheet.vue";

const timesheetRoutes: Array<RouteRecordRaw> = [
    {
        path: '/timesheet/',
        meta: {'app': 'tim', 'permission': 'access timesheet'},
        components: {
            default: HomeProgetti,
            nav: TimesheetMenu,
        },
        children: [
            {
                path: 'inserisci',
                name: 'Timesheet',
                component: InserimentoTimesheet,
            },
            {
                path: 'controllo',
                name: 'ControlloTimesheet',
                component: ControlloTimesheet,
            },
        ],
    },
]

export default timesheetRoutes
